import http from '../utils/http'

var USER_BASE = '/api/user'
var APP_KEY = 'cmgamebox2025'

function getDeviceId() {
  var key = 'gc_device_id'
  var id = localStorage.getItem(key)
  if (!id) {
    id = 'web_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10)
    localStorage.setItem(key, id)
  }
  return id
}

/** 匿名登录（deviceId + appKey） */
export function login() {
  return http.post(USER_BASE + '/login', {
    deviceId: getDeviceId(),
    appKey: APP_KEY
  })
}

/** APP 内 CMCC token 换游戏中心 token */
export function loginWithCmccToken(cmccToken) {
  return http.post(USER_BASE + '/login/cmcc', {
    cmccToken: cmccToken,
    deviceId: getDeviceId(),
    appKey: APP_KEY
  })
}

/** 通过 URL 中的 JWT 登录 */
export function loginWithJwt(jwt) {
  return http.get(USER_BASE + '/login', { params: { jwt } })
}

/** 获取用户信息 */
export function getUserInfo(userId) {
  return http.get(USER_BASE + '/' + userId)
}

/** 修改昵称 */
export function updateNickname(userId, nickname) {
  return http.put(USER_BASE + '/' + userId + '/nickname', { nickname: nickname })
}

/** 退出登录 */
export function logout(userId) {
  return http.post(USER_BASE + '/logout', { userId: userId })
}

/** 添加/更新常用游戏 */
export function addOrUpdateFavorite(userId, gameId) {
  return http.get(USER_BASE + '/favorite/addOrUpdate', {
    params: { userId: userId, gameId: gameId }
  })
}

/** 删除常用游戏 */
export function removeFavorite(userId, gameId) {
  return http.get(USER_BASE + '/favorite/remove', {
    params: { userId: userId, gameId: gameId }
  })
}

/** 获取常用游戏列表 */
export function getFavorites(userId) {
  return http.get(USER_BASE + '/favorite/list', {
    params: { userId: userId }
  }).catch(function() { return [] })
}
